import { Grid } from '@mui/material';
import { useEffect } from 'react';

interface AnimatedLeftStepProps {
  id: string;
  isVisible: boolean;
  children: React.ReactElement;
  disabled?: boolean;
}

export const AnimatedLeftStep = ({
  id,
  isVisible,
  children,
  disabled = false,
}: React.PropsWithChildren<AnimatedLeftStepProps>) => {
  useEffect(() => {
    if (!disabled) {
      if (!isVisible) {
        const element = document.getElementById(id);
        if (element) {
          element.classList.remove(`animate__fadeInUp`);
          element.classList.add(`animate__fadeOutUp`);
        }
      } else {
        const element = document.getElementById(id);
        if (element) {
          element.classList.remove(`animate__fadeOutUp`);
          element.classList.add(`animate__fadeInUp`);
        }
      }
    }
  }, [isVisible, id, disabled]);

  return (
    <Grid
      id={id}
      container
      direction="column"
      alignItems="center"
      wrap="nowrap"
      className={disabled ? undefined : `animate__animated animate__fadeInUp`}
    >
      {children}
    </Grid>
  );
};
